import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"
import _imports_0 from '../assets/logo.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-caption pt-5" }, "Header Vorschau", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-caption pt-5" }, "Footer Vorschau", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-caption pt-5" }, "Neutraler Header Vorschau", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-caption pt-5" }, "Neutraler Footer Vorschau", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-caption pt-5" }, "Unterschrift Vorschau", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_error_snackbar = _resolveComponent("error-snackbar")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_error_snackbar, {
      snackbar: _ctx.errorSnackbar,
      "onUpdate:snackbar": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.errorSnackbar) = $event))
    }, null, 8, ["snackbar"]),
    _createVNode(_component_v_container, { fluid: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  style: {"min-height":"200px"},
                  class: "pt-5"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "4" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_img, {
                              src: _imports_0,
                              height: "150px"
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "4" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.store.state.user.username), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_card_subtitle, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.lastLogin), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_card_text, null, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.store.state.user.roles, (user, index) => {
                                  return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(user), 1))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_divider),
                _createVNode(_component_v_card, { class: "mt-4" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode("Allgemeine Einstellungen")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          label: "Dokumenteansicht",
                          items: _ctx.documentType,
                          "item-value": "key",
                          "item-title": "name",
                          modelValue: _ctx.selectedDocumentView,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedDocumentView) = $event))
                        }, null, 8, ["items", "modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_actions, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_btn, {
                          color: "darken-1",
                          variant: "tonal",
                          text: "",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.saveSettings()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Speichern")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card, { class: "mt-4" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode("Password ändern")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_form, {
                          ref: "passwordForm",
                          modelValue: _ctx.isPasswordFormValid,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.isPasswordFormValid) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.passwordChange.oldPassword,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.passwordChange.oldPassword) = $event)),
                              label: "Altes Passwort",
                              required: "",
                              type: "password"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.passwordChange.password,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.passwordChange.password) = $event)),
                              label: "Neues Passwort",
                              rules: [_ctx.passwordRules.required, _ctx.passwordRules.minLength],
                              required: "",
                              type: "password"
                            }, null, 8, ["modelValue", "rules"]),
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.passwordChange.passwordRetry,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.passwordChange.passwordRetry) = $event)),
                              label: "Neues Passwort wiederholen",
                              rules: [_ctx.passwordRules.required, _ctx.passwordRules.matchPassword, _ctx.passwordRules.minLength],
                              type: "password"
                            }, null, 8, ["modelValue", "rules"]),
                            _createVNode(_component_v_card_actions, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_spacer),
                                _createVNode(_component_v_btn, {
                                  color: "darken-1",
                                  variant: "tonal",
                                  text: "",
                                  disabled: !_ctx.isPasswordFormValid,
                                  onClick: _ctx.changePassword
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Speichern ")
                                  ]),
                                  _: 1
                                }, 8, ["disabled", "onClick"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        (_ctx.passwordMessage)
                          ? (_openBlock(), _createBlock(_component_v_alert, {
                              key: 0,
                              type: _ctx.passwordMessage.type,
                              class: "mt-3"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.passwordMessage.text), 1)
                              ]),
                              _: 1
                            }, 8, ["type"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode("Template Images")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_form, null, {
                          default: _withCtx(() => [
                            _hoisted_1,
                            _createVNode(_component_v_img, { src: _ctx.headerImage }, null, 8, ["src"]),
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.headerImage,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.headerImage) = $event)),
                              label: "Header für Templates"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_v_divider),
                            _hoisted_2,
                            _createVNode(_component_v_img, { src: _ctx.footerImage }, null, 8, ["src"]),
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.footerImage,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.footerImage) = $event)),
                              label: "Footer für Templates"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_v_card_actions, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_spacer),
                                _createVNode(_component_v_btn, {
                                  color: "darken-1",
                                  variant: "tonal",
                                  text: "",
                                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.saveTemplateImages(false)))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Speichern")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (_ctx.templateMessage)
                          ? (_openBlock(), _createBlock(_component_v_alert, {
                              key: 0,
                              type: _ctx.templateMessage.type,
                              class: "mt-3"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.templateMessage.text), 1)
                              ]),
                              _: 1
                            }, 8, ["type"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card, { class: "mt-5" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode("Neutrale Template Images")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_form, null, {
                          default: _withCtx(() => [
                            _hoisted_3,
                            _createVNode(_component_v_img, { src: _ctx.headerImageNeutral }, null, 8, ["src"]),
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.headerImageNeutral,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.headerImageNeutral) = $event)),
                              label: "Neutraler Header für Templates"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_v_divider),
                            _hoisted_4,
                            _createVNode(_component_v_img, { src: _ctx.footerImageNeutral }, null, 8, ["src"]),
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.footerImageNeutral,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.footerImageNeutral) = $event)),
                              label: "Neutraler Footer für Templates"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_v_card_actions, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_spacer),
                                _createVNode(_component_v_btn, {
                                  color: "darken-1",
                                  variant: "tonal",
                                  text: "",
                                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.saveTemplateImages(true)))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Speichern")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (_ctx.templateMessageNeutral)
                          ? (_openBlock(), _createBlock(_component_v_alert, {
                              key: 0,
                              type: _ctx.templateMessageNeutral.type,
                              class: "mt-3"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.templateMessageNeutral.text), 1)
                              ]),
                              _: 1
                            }, 8, ["type"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card, { class: "mt-5" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode("Unterschrift für Templates")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_form, null, {
                          default: _withCtx(() => [
                            _hoisted_5,
                            _createVNode(_component_v_img, {
                              src: _ctx.signature,
                              style: {"width":"auto"}
                            }, null, 8, ["src"]),
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.signature,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.signature) = $event)),
                              label: "Unterschrift für Templates"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_v_card_actions, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_spacer),
                                _createVNode(_component_v_btn, {
                                  color: "darken-1",
                                  variant: "tonal",
                                  text: "",
                                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.saveSignature()))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Speichern")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (_ctx.templateMessageSignature)
                          ? (_openBlock(), _createBlock(_component_v_alert, {
                              key: 0,
                              type: _ctx.templateMessageSignature.type,
                              class: "mt-3"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.templateMessageSignature.text), 1)
                              ]),
                              _: 1
                            }, 8, ["type"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}